export interface IResponsiveContext {
	isBrowser(): boolean;

	isMobile(): boolean;

	isTablet(): boolean;
}
